import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b140532"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "transaction-details-content" }

import { useRouter } from 'vue-router'
import { onMounted, ref } from 'vue'
import browser from 'webextension-polyfill'

import { useFixedHeader } from '@/popup/compositions/useFixedHeader'
import TransactionContent from '@/popup/components/Transaction/TransactionContent.vue'
import IconButton from '@/popup/components/shared/IconButton.vue'
import { useAppStore } from '@/popup/store/AppStore'
import { urlReplace } from '@/shared/utils'
import ClipboardCopy from '@/popup/components/shared/ClipboardCopy/ClipboardCopy.vue'
import {
  Transaction,
  TransactionChangeMessage,
} from '@/shared/models/Transaction'
import { usePreferencesStore } from '@/popup/store/PreferencesStore'

type Props = {
  transaction?: Transaction
}

type Emits = {
  (event: 'on-transaction-change', message?: TransactionChangeMessage): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionDetails',
  props: {
    transaction: {}
  },
  emits: ["on-transaction-change"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const router = useRouter()

const preferences = usePreferencesStore()
const appStore = useAppStore()
const explorerUrl = appStore.network.explorer?.url
const onMountedRun = ref(false)
const contentRef = ref<InstanceType<typeof HTMLElement>>()
const scrollOffset = ref<number>(100)
const { onContentScroll, isFixedHeader, scrollPercentage } = useFixedHeader(
  scrollOffset,
  contentRef
)

onMounted(() => {
  onMountedRun.value = true
})

const openExplorerLink = () => {
  if (props.transaction?.transactionHash && explorerUrl) {
    browser.tabs.create({
      url: urlReplace(
        explorerUrl,
        'transactionId',
        props.transaction?.transactionHash
      ),
    })
  }
}

const onTransactionChange = (event: TransactionChangeMessage) => {
  emits('on-transaction-change', event)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    ref_key: "contentRef",
    ref: contentRef,
    class: _normalizeClass(`transaction-details-window ${onMountedRun.value ? 'loaded' : ''}`),
    onScrollPassive: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(onContentScroll) && _unref(onContentScroll)(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TransactionContent, {
        transaction: _ctx.transaction,
        components: _ctx.transaction?.components,
        preferences: _unref(preferences),
        "is-fixed-header": _unref(isFixedHeader),
        "scroll-percentage": _unref(scrollPercentage),
        class: "top-part",
        onOnTransactionChange: onTransactionChange,
        onHeaderOffset: _cache[1] || (_cache[1] = 
          value => {
            scrollOffset.value = value
          }
        )
      }, {
        rightActions: _withCtx(() => [
          _createVNode(IconButton, {
            onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/home')))
          })
        ]),
        leftActions: _withCtx(() => [
          (_ctx.transaction?.transactionHash)
            ? (_openBlock(), _createBlock(ClipboardCopy, {
                key: 0,
                value: _ctx.transaction.transactionHash,
                "hover-text": _ctx.$t('transaction.details.copy_transaction_id'),
                "copy-text": _ctx.$t('transaction.details.copy_transaction_id'),
                "offset-distance": "7"
              }, {
                default: _withCtx(() => [
                  _createVNode(IconButton, { name: "copy" })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["value", "hover-text", "copy-text"]))
            : _createCommentVNode("v-if", true),
          (_ctx.transaction?.transactionHash && _unref(explorerUrl))
            ? (_openBlock(), _createBlock(IconButton, {
                key: 1,
                name: "link-3",
                class: "ml-1",
                tooltip: _ctx.$t('transaction.details.view_explorer'),
                onOnClick: openExplorerLink
              }, null, 8 /* PROPS */, ["tooltip"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["transaction", "components", "preferences", "is-fixed-header", "scroll-percentage"])
    ])
  ], 34 /* CLASS, NEED_HYDRATION */))
}
}

})